module.exports = __webpack_public_path__ + "img/case-logo-34.48f79791.png";